import {
    ILLUSTRATION_TAG_ID,
    ANIMATION_TAG_ID,
    BOOK_TAG_ID,
    INFOGRAPHICS_TAG_ID,

    BRAND_TAG_ID,
    FASHION_TAG_ID,
    ART_TAG_ID,
    DESIGN_EDUCATION_TAG_ID,
    INTERIOR_TAG_ID,
    LANDSCAPING_TER_ID,
    PUBLIC_PLACE_ID,
    TERRITORIAL_BRANDING_ID,
    URBAN_ENVIRONMENT_ID,
    DESIGN_TAG_ID,
    JEWELRY_TAG_ID,

    ADVERTISING_TAG_ID,
    ART_DIRECTION_TAG_ID,
    ANIMATION_FOR_HSEPERM_TAG_ID,
    WEB_PUBLISH_TAG_ID,
    BOOK_DESIGN_TAD_ID,
    BASIC_DESIGN_TA_ID,
    COMMUNICATION_TAG_ID,
    CREATIVE_PROGRAMMING_TAG_ID,
    DIGITAL_PRODUCT_TAG_ID,
    INTERACTIVE_DESIGN_TAG_ID,
    MEDIA_DESIGN_TAG_ID,
    MODERN_DESIGN_TAG_ID,
    OBJECT_DESIGN_TAG_ID,
    PACKAGING_TAG_ID,
    TYPE_TAG_ID,
    CANTEMPORARY_ART_TAG_ID,
    PHOTOGRAPHY_ART_TAG_ID,
    VIDEO_ART_ART_TAG_ID,
    FASHION_MANT_TAG_ID,
    TOUR_TAG_ID,

    COLAB_ID,
    FASHION_COLAB_ID,
    BOOK_DESIGN_ID,
    CHILD_BOOK_ID,
    VIMMELBUH_ID,
    CALENDAR_DESIGN_ID,
    CURATOR_ID,
    VIRTUAL_ID,
    PICTURE_BOOK_ID,
    PERFORMANS_ID,
    PUBLIC_ART_ID,
    DESIGN_HISTORY_ID,
    ART_HISTORY_ID,
    COMICS_TAG_ID,
    ILLUSTRATION_IDENTIC_ID,
    VISUAL_RES_TAG_ID_BL,
    BASE_COURSE_ANIMATION_TAG_ID,
    GAME_DESIGN_TAG_ID,
    DESIGN_HSEPERM_TAG_ID,
    BASE_COMMUN_DESIGN_TAG_ID,
    BASIC_DESIGN_COURSE_TAG_ID,
    EVENTS_TAD_ID,
    SPACE_TAG_ID,
    ARTIST_TAG_ID,
    GALLERYS_TAG_ID,
    RUSSIA_TAG_ID,
    EU_TAG_ID,
    STARTSUP_TAG_ID,
    HSE_ART_TAG_ID,
    PLACES_TAG_ID,

    AUSTRIA_TAG_ID,
    GB_TAG_ID,
    GER_TAG_ID,
    IRL_TAG_ID,
    LIHT_TAG_ID,
    LUX_TAG_ID,
    FR_TAG_ID,
    SWISS_TAG_ID,
    ISL_TAG_ID,
    POL_TAG_ID,
    NOWR_TAG_ID,
    FINL_TAG_ID,
    SWE_TAG_ID,
    SPAIN_TAG_ID,
    IT_TAG_ID,
    FOOD_TAG_ID,
    INTERIOR_DESIGN_TAG_ID,
    RUS_FOOD_TAG_ID,
    GOR_FOOD_TAG_ID,
    JAP_FOOD_TAG_ID,
    IT_FOOD_TAG_ID,
    FR_FOOD_TAG_ID,
    CHI_FOOD_TAG_ID,
    SPA_FOOD_TAG_ID,
    MEX_FOOD_TAG_ID,
    IND_FOOD_TAG_ID,
    TUR_FOOD_TAG_ID,
    AR_FOOD_TAG_ID,
    TAI_FOOD_TAG_ID,
    KOR_FOOD_TAG_ID,
    AFR_FOOD_TAG_ID,
    CULTURE_TAG_ID,
    ARCH_TAG_ID,
    LIT_TAG_ID,
    MUSIC_TAG_ID,
    THEATRE_TAG_ID,
    EXPOSITION_TAG_ID,
    NATION_CRAFT_TAG_ID,
    CITIES_TAG_ID,
    CREATIVE_FUTURES_TAG_ID,
    DESIGN_FUTURES_TAG_ID,
    INTER_DESIGN_TAG_ID,
    HISTORY_INVESTIGATE_TAG_ID,

    CONF_TAG_ID,
    FEST_TAG_ID,
    PERFORMANCE_TAG_ID,
    THEATER_AND_PERF_TAG_ID,
    SHADOW_THEATRE_TAG_ID,
    FESTIVAL_TAG_ID,
    SHOW_TAG_ID,
    VISUAL_RESEARCH_TAG_GRADUATION_BLACK,
    VISUAL_RESEARCH_TAG_GRADUATION_WHITE,
    CREATIVE_BU_TAG_ID,
    NATURE_DESIGN_TAG_ID,

    RESEARCH_TAG_ID,
    THEMES_TAG_ID,
    ALL_RESEARCH_TAG_ID,

    SOUND_TAG_ID,
    SOUND_ART_TAG_ID,
    RESTAURANT_TAG_ID,
    CAFE_TAG_ID,
    PEOPLE_TAG_ID,
    FINANCE_TAG_ID,
    NATURE_TAG_ID,
    ECOLOGY_TAG_ID,
    FLORA_AND_FAUNA_TAG_ID,
    SPORT_TAG_ID,
    CREATIVE_COOK_TAG_ID,
    HOLIDAYS_TAG_ID,
    VIDEO_ART_TAG_ID,
    MODERN_ART_TAG_ID,
    HSELAB_DESIGN_TAG_ID,
    EVENTS_DESIGN_TAG_ID,
    MANAGEMENT_TAG_ID,
    BASE_DESIGN_COURSE,
    COOKING_ID,
    GAME_FUTURES_TAG_ID,
    MUSEUM_TAG_ID,
    MUSEUM_NEW_TAG_ID,
    LIBRARY_TAG_ID,
    TRANSPORT_TAG_ID,
    INDUSTRY_TAG_ID,
    BRANDS_TAG_ID,

    D_PERSON_TAG_ID,
    D_MODEL_TAG_ID,
    VIDEO_GAME_TAG_ID,
    GAME_GRAPHIC_TAG_ID,
    ANIMATIC_TAG_ID,
    FANTASY_TAG_ID,
    ILLUSTRATED_BOOK_TAG_ID,
    FOOD_PACKAGINGLAB_TAG,
    FOOD_PACKAGINGLAB_TAG_ID,
    BEVERAGE_PACKAGINGLAB_TAG,
    BEVERAGE_PACKAGINGLAB_TAG_ID,
    BODY_PACKAGINGLAB_TAG,
    BODY_PACKAGINGLAB_TAG_ID,
    ADCODINGHUB_TAG,
    AILAB_TAG,
    AI_TAG_ID,
    HSEFONTS_TAG,
    PRINTING_HOUSE_TAG,
    HSEMULTIMEDIA_TAG,
    TERBRANDING_TAG,
    HSEPOSTERLAB_TAG,
    POSTER_TAG_ID,
    HSESCREENS_TAG,
    HSECOLLECTION_PORCELAIN_TAG_ID,
    HSECOLLECTION_TEXTILE_TAG_ID,
    HSECOLLECTION_SILCSCREEN_TAG_ID,
    HSECOLLECTION_CALENDARS_TAG_ID,
    HSECOLLECTION_PORCELAIN_TAG,
    HSECOLLECTION_TEXTILE_TAG,
    HSECOLLECTION_SILCSCREEN_TAG,
    HSECOLLECTION_CALENDARS_TAG,
    HSEPHOTOLAB_TAG,
    EDUDESIGN_TAG,
    EDU_BRANDING_TAG_ID,
    CAMPUS_TAG_ID,
    PRODUCTION_TAG,

    ARRANGEMENT_TAG_ID,
    VOCAL_MUSIC_TAG_ID,
    CLASSIC_MUSIC_TAG_ID,
    MIX_TAG_ID,
    MUSICAL_COMPOSITION_TAG_ID,
    MUSICAL_ALBUM_TAG_ID,
    POP_MUSIC_TAG_ID,
    ROCK_MUSIC_TAG_ID,
    MIXING_AND_MASTERING_TAG_ID,
    DANCING_MUSIC_TAG_ID,
    INSTR_MUSIC_TAG_ID,

    SOUND_PRODUCTION_TAG_ID,
    MUSICAL_PROJECT_TAG_ID,
    STUDIO_RECORDING_TAG_ID,
    ORCHESTRA_TAG_ID,
    PRESS_PACK_TAG_ID,
    SOUND_SINTHESIS_TAG_ID,
    AUDIOMEDIA_TAG_ID,
    SOUND_DESIGN_TAG,

    SOUND_IDENTITY_TAG_ID,
    AUDIO_BRANDING_TAG_ID,
    SOUND_LIBRARY_TAG_ID,
    ANIMATION_MUSIC_TAG_ID,
    FILMS_MUSIC_TAG_ID,
    CATWALK_MUSIC_TAG_ID,
    ADVERTISING_MUSIC_TAG_ID,
    THEATRE_MUSIC_TAG_ID,
    PATCH_TAG_ID,
    SOUND_TRACK_TAG_ID,
    BACKGROUND_MUSIC_TAG_ID,
    FUNCTIONAL_MUSIC_TAG_ID,
    SOUND_DESIGN_TAG_ID,
    SOUND_ART_TAG,

    SOUND_INSTALLATION_TAG_ID,
    SOUND_SCULPTURE_TAG_ID,
    MULTI_INSTALLATION_TAG_ID,
    MULTIMEDIA_PERFORMANCE_TAG_ID,
    FIELD_RECORDS_TAG_ID,
    EXP_MUSIC_TAG_ID,
    ELECTROACOUSTIC_MUSIC_TAG_ID,

    SOUNDART_TAG_ID,
    NOISE_MUSIC_TAG_ID,
    MUSIC_PRACTICE_TAG_ID,
    SOUNDSCAPE_TAG_ID,
    SONIFICATION_TAG_ID,
    ALHORITMIC_MUSIC_TAG_ID,
    SOUND_POETRY_TAG_ID,
    MUSIC_CONCRETE_TAG_ID,
    STUDIES_TAG,

    SOUND_STUDIES_TAG_ID,
    MUSICAL_CRITICISM,
    SOUND_PHILOSOPHY,
    SOUND_ECOLOGY_TAG_ID,
    SOUNDLAB_TAG,

    MUSICAL_LABEL_TAG_ID,
    SOUNDLAB_TAG_ID,
    AD_POSTER_TAG, SOCIAL_POSTER_TAG, THEATER_POSTER_TAG, MUSEUM_BRANDING_TAG, MUSEUM_DESIGN_TAG,
    EXPLAINERS_TAG_ID,
    TVDESIGN_TAG_ID,
    MUSIC_CLIPS_TAG_ID,
    DDD_POST_PROD_TAG_ID,
    SOUND_ALL_TAG,
    DIGITAL_ART_NEW_TAG_ID, 
    FINE_ART_TAG_ID,
    EDUCATION_COURSE,
    BASE_COURSE_MODERN_DESIGN_TAG_ID,
    DIGITAL_ART_TAG_ID,
    CINEMA_TAG_ID,
    EVENT_MANAGER_TAG_ID,
    MEDIA_STARTUP_TAG_ID,
    PRODUCER_TAG_ID,
    PRINT_PRODUCT_TAG_ID,
    MANU_DESIGN_TAG_ID,
    HSEILLUSTRATION_TAG_ID,
    CONCEPT_ART_TAG_ID,
    CGI_TAG_ID,
    VIDEO_TAG_ID,
    BOARD_GAME_ID


} from '../../../constants/misc';
import { ContextCodes } from './tabs';

export const getContextTagsFilterParam = (id: string, context?: string): string[] | null => {
    if (context === ContextCodes.deziiignMain) {
        switch (id) {
            case DESIGN_TAG_ID:
                return [
                    ART_DIRECTION_TAG_ID, 
                    PACKAGING_TAG_ID, 
                    INFOGRAPHICS_TAG_ID, 
                    INTERACTIVE_DESIGN_TAG_ID, 
                    PRINT_PRODUCT_TAG_ID, 
                    MEDIA_DESIGN_TAG_ID, 
                    POSTER_TAG_ID, 
                    ADVERTISING_TAG_ID, 
                    TYPE_TAG_ID, 
                    DIGITAL_PRODUCT_TAG_ID, 
                    CREATIVE_PROGRAMMING_TAG_ID, 
                    WEB_PUBLISH_TAG_ID, 
                    MEDIA_DESIGN_TAG_ID, 
                    // AI_TAG_ID, 
                    BOOK_TAG_ID
                ]
            case 'product':
                return [
                    OBJECT_DESIGN_TAG_ID, 
                    MANU_DESIGN_TAG_ID, 
                    JEWELRY_TAG_ID
                ]
            case 'environment':
                return [
                    INTER_DESIGN_TAG_ID,
                    NATURE_DESIGN_TAG_ID
                ]
            case ILLUSTRATION_TAG_ID:
                return [
                    HSEILLUSTRATION_TAG_ID,
                    COMICS_TAG_ID,
                    CHILD_BOOK_ID,
                    BOARD_GAME_ID 
                ]
        }
    }
    switch (id) {
        case EDUCATION_COURSE:
            return [EDUCATION_COURSE]
        case EXPLAINERS_TAG_ID:
            return [EXPLAINERS_TAG_ID]
        case TVDESIGN_TAG_ID:
            return [TVDESIGN_TAG_ID]
        case MUSIC_CLIPS_TAG_ID:
            return [MUSIC_CLIPS_TAG_ID]
        case DDD_POST_PROD_TAG_ID:
            return [DDD_POST_PROD_TAG_ID]
        case SOUNDLAB_TAG:
            return [
                MUSICAL_LABEL_TAG_ID,
                SOUNDLAB_TAG_ID,
            ]
        case SOUND_ALL_TAG:
            return [
                SOUND_TAG_ID
            ]
        case STUDIES_TAG:
            return [
                SOUND_STUDIES_TAG_ID,
                // MUSICAL_CRITICISM,
                // SOUND_PHILOSOPHY,
                // SOUND_ECOLOGY_TAG_ID,
            ]
        case SOUND_ART_TAG:
            return [
                // SOUND_INSTALLATION_TAG_ID,
                // SOUND_SCULPTURE_TAG_ID,
                // MULTI_INSTALLATION_TAG_ID,
                // MULTIMEDIA_PERFORMANCE_TAG_ID,
                // FIELD_RECORDS_TAG_ID,
                // EXP_MUSIC_TAG_ID,
                // ELECTROACOUSTIC_MUSIC_TAG_ID,

                SOUNDART_TAG_ID,
                // NOISE_MUSIC_TAG_ID,
                // MUSIC_PRACTICE_TAG_ID,
                // SOUNDSCAPE_TAG_ID,
                // SONIFICATION_TAG_ID,
                // ALHORITMIC_MUSIC_TAG_ID,
                // SOUND_POETRY_TAG_ID,
                // MUSIC_CONCRETE_TAG_ID,
            ]
        case SOUND_DESIGN_TAG: 
            return [
                // SOUND_IDENTITY_TAG_ID,
                // AUDIO_BRANDING_TAG_ID,
                // SOUND_LIBRARY_TAG_ID,
                // ANIMATION_MUSIC_TAG_ID,
                // FILMS_MUSIC_TAG_ID,
                // CATWALK_MUSIC_TAG_ID,
                // ADVERTISING_MUSIC_TAG_ID,
                // THEATRE_MUSIC_TAG_ID,
                // PATCH_TAG_ID,
                // SOUND_TRACK_TAG_ID,
                // BACKGROUND_MUSIC_TAG_ID,
                // FUNCTIONAL_MUSIC_TAG_ID,
                SOUND_DESIGN_TAG_ID,
            ]
        case PRODUCTION_TAG:
            return [
                // ARRANGEMENT_TAG_ID,
                // VOCAL_MUSIC_TAG_ID,
                // CLASSIC_MUSIC_TAG_ID,
                // MIX_TAG_ID,
                // MUSICAL_COMPOSITION_TAG_ID,
                // MUSICAL_ALBUM_TAG_ID,
                // POP_MUSIC_TAG_ID,
                // ROCK_MUSIC_TAG_ID,
                // MIXING_AND_MASTERING_TAG_ID,
                // DANCING_MUSIC_TAG_ID,
                // INSTR_MUSIC_TAG_ID,

                SOUND_PRODUCTION_TAG_ID,
                // MUSICAL_PROJECT_TAG_ID,
                // STUDIO_RECORDING_TAG_ID,
                // ORCHESTRA_TAG_ID,
                // PRESS_PACK_TAG_ID,
                // SOUND_SINTHESIS_TAG_ID,
                // AUDIOMEDIA_TAG_ID,
            ]
        case EDUDESIGN_TAG:
            return [EDU_BRANDING_TAG_ID, DESIGN_EDUCATION_TAG_ID, CAMPUS_TAG_ID]
        case HSECOLLECTION_PORCELAIN_TAG:
            return  [
                HSECOLLECTION_PORCELAIN_TAG_ID
            ]
        case HSECOLLECTION_TEXTILE_TAG:
            return [HSECOLLECTION_TEXTILE_TAG_ID]
        case HSECOLLECTION_SILCSCREEN_TAG:
            return [
                HSECOLLECTION_SILCSCREEN_TAG_ID
            ]
        case HSECOLLECTION_CALENDARS_TAG:
            return [HSECOLLECTION_CALENDARS_TAG_ID]

        case D_PERSON_TAG_ID:
            return [D_PERSON_TAG_ID, D_MODEL_TAG_ID]
        case VIDEO_GAME_TAG_ID:
            return [VIDEO_GAME_TAG_ID, GAME_GRAPHIC_TAG_ID]
        case ANIMATIC_TAG_ID:
            return [ANIMATIC_TAG_ID]
        case TOUR_TAG_ID: 
            return [TOUR_TAG_ID]
        case PEOPLE_TAG_ID:
            return [PEOPLE_TAG_ID, ARTIST_TAG_ID]
        case FINANCE_TAG_ID:
            return [ TRANSPORT_TAG_ID, /*INDUSTRY_TAG_ID, */BRANDS_TAG_ID, TRANSPORT_TAG_ID]
        case NATURE_TAG_ID: 
            return [NATURE_TAG_ID, ECOLOGY_TAG_ID, FLORA_AND_FAUNA_TAG_ID]
        case SPORT_TAG_ID:
            return [SPORT_TAG_ID]
        case CREATIVE_COOK_TAG_ID:
            return [
                FOOD_TAG_ID,
                RUS_FOOD_TAG_ID,
                GOR_FOOD_TAG_ID,
                JAP_FOOD_TAG_ID,
                IT_FOOD_TAG_ID,
                FR_FOOD_TAG_ID,
                CHI_FOOD_TAG_ID,
                SPA_FOOD_TAG_ID,
                MEX_FOOD_TAG_ID,
                IND_FOOD_TAG_ID,
                TUR_FOOD_TAG_ID,
                AR_FOOD_TAG_ID,
                TAI_FOOD_TAG_ID,
                KOR_FOOD_TAG_ID,
                AFR_FOOD_TAG_ID,
            ]
        case HOLIDAYS_TAG_ID:
            return [
                HOLIDAYS_TAG_ID,
                 EVENTS_TAD_ID,

                 CONF_TAG_ID,
                 FEST_TAG_ID,
                 PERFORMANCE_TAG_ID,
                 THEATER_AND_PERF_TAG_ID,
                 SHADOW_THEATRE_TAG_ID,
                 FESTIVAL_TAG_ID,
                 SHOW_TAG_ID,
                ]
        case SOUND_ART_TAG_ID:
            return [SOUND_ART_TAG_ID]
        case THEMES_TAG_ID:
            return [DESIGN_TAG_ID]
        case RESEARCH_TAG_ID:
            return [RESEARCH_TAG_ID]
        case HISTORY_INVESTIGATE_TAG_ID:
            return [HISTORY_INVESTIGATE_TAG_ID]
        case ALL_RESEARCH_TAG_ID: 
            return null
      case ILLUSTRATION_TAG_ID:
        return [
            HSEILLUSTRATION_TAG_ID,
            COMICS_TAG_ID,
            CONCEPT_ART_TAG_ID
        ]
  
      case ANIMATION_TAG_ID:
        return [ANIMATION_TAG_ID]
  
      case BOOK_TAG_ID:
          if (context === 'ageytomesh') {
              return []
          }
        return [BOOK_TAG_ID, COMICS_TAG_ID]

        case COMICS_TAG_ID:
            return [COMICS_TAG_ID]

        case ILLUSTRATED_BOOK_TAG_ID:
            return [ILLUSTRATED_BOOK_TAG_ID, VIMMELBUH_ID, PICTURE_BOOK_ID, CHILD_BOOK_ID]
  
        case INFOGRAPHICS_TAG_ID:
        return [INFOGRAPHICS_TAG_ID]

        case DESIGN_FUTURES_TAG_ID:
            return [        
                JEWELRY_TAG_ID,
                OBJECT_DESIGN_TAG_ID,
                COMMUNICATION_TAG_ID,
                NATURE_DESIGN_TAG_ID,
                INTER_DESIGN_TAG_ID
            ]

        case DESIGN_TAG_ID: 
        return [
            // ADVERTISING_TAG_ID,
            // ART_DIRECTION_TAG_ID, 
            // WEB_PUBLISH_TAG_ID, 
            // BOOK_DESIGN_TAD_ID, 
            // // BASIC_DESIGN_TA_ID, 
            // COMMUNICATION_TAG_ID,
            // CREATIVE_PROGRAMMING_TAG_ID,
            // DIGITAL_PRODUCT_TAG_ID,
            // INTERACTIVE_DESIGN_TAG_ID,
            // MEDIA_DESIGN_TAG_ID,
            // // MODERN_DESIGN_TAG_ID,
            // OBJECT_DESIGN_TAG_ID,
            // PACKAGING_TAG_ID,
            // TYPE_TAG_ID

            THEATER_AND_PERF_TAG_ID,
            EVENT_MANAGER_TAG_ID,
            CREATIVE_BU_TAG_ID,
            MEDIA_STARTUP_TAG_ID,
            PRODUCER_TAG_ID,
            ART_DIRECTION_TAG_ID,
            BASIC_DESIGN_COURSE_TAG_ID,
            WEB_PUBLISH_TAG_ID,
            BOOK_TAG_ID,
            PACKAGING_TAG_ID,
            INFOGRAPHICS_TAG_ID,
            AI_TAG_ID,

            DDD_POST_PROD_TAG_ID,
            CGI_TAG_ID,
            ANIMATION_TAG_ID,
            VIDEO_TAG_ID,
            VIDEO_ART_TAG_ID,
            CINEMA_TAG_ID,
            PRODUCER_TAG_ID,
            CREATIVE_PROGRAMMING_TAG_ID,
            INTERACTIVE_DESIGN_TAG_ID,
            PRINT_PRODUCT_TAG_ID,
            POSTER_TAG_ID,
            ADVERTISING_TAG_ID,
            DIGITAL_PRODUCT_TAG_ID,
            TYPE_TAG_ID,
            MEDIA_DESIGN_TAG_ID,
            OBJECT_DESIGN_TAG_ID,
            MANU_DESIGN_TAG_ID,
            JEWELRY_TAG_ID,
            HSEILLUSTRATION_TAG_ID,
            COMICS_TAG_ID,
            CONCEPT_ART_TAG_ID,
            // SOUND_TAG_ID


        ]

        case INTERIOR_TAG_ID:
            return [
                INTERIOR_TAG_ID, 
                PUBLIC_PLACE_ID,
                NATURE_DESIGN_TAG_ID,
                INTERIOR_DESIGN_TAG_ID
            ]

        case DESIGN_EDUCATION_TAG_ID: 
            return [DESIGN_EDUCATION_TAG_ID]

        case HSELAB_DESIGN_TAG_ID:
            return [
                ART_DIRECTION_TAG_ID, 
                BOOK_DESIGN_TAD_ID, 
                COMMUNICATION_TAG_ID,
                OBJECT_DESIGN_TAG_ID,
                EVENTS_DESIGN_TAG_ID
            ]

        case TERRITORIAL_BRANDING_ID:
            return [
                LANDSCAPING_TER_ID, 
                URBAN_ENVIRONMENT_ID, 
                TERRITORIAL_BRANDING_ID,
                NATION_CRAFT_TAG_ID,
                CITIES_TAG_ID,
                PLACES_TAG_ID
            ]

        case ART_TAG_ID:
            return [
                CANTEMPORARY_ART_TAG_ID,
                PHOTOGRAPHY_ART_TAG_ID,
                VIDEO_ART_ART_TAG_ID
            ]
        case FASHION_MANT_TAG_ID: 
            return [FASHION_TAG_ID]
        
        case GAME_FUTURES_TAG_ID: 
            return [GAME_DESIGN_TAG_ID]

        case FASHION_TAG_ID:
            return [
                FASHION_TAG_ID,
                PHOTOGRAPHY_ART_TAG_ID
            ]
        case 'environment': 
        return [
            INTER_DESIGN_TAG_ID,
            NATURE_DESIGN_TAG_ID
        ]

        case COLAB_ID: 
            return [COLAB_ID]

        case FASHION_COLAB_ID:
            return [FASHION_COLAB_ID]
        
        case CURATOR_ID :
            return [CURATOR_ID];
            
        case PICTURE_BOOK_ID:
            return [PICTURE_BOOK_ID]
        
        case PERFORMANS_ID:
            return [PERFORMANS_ID]
        
        case PUBLIC_ART_ID:
            return [PUBLIC_ART_ID]

        case DESIGN_HISTORY_ID:
            return [DESIGN_HISTORY_ID]
            // return [DESIGN_HISTORY_ID, VISUAL_RES_TAG_ID_BL, VISUAL_RES_TAG_ID_WHT]
        
        case ART_HISTORY_ID:
            return [ART_HISTORY_ID]
            // return [ART_HISTORY_ID, VISUAL_RES_TAG_ID_BL, VISUAL_RES_TAG_ID_WHT]

        case BOOK_DESIGN_ID: 
            return [BOOK_DESIGN_ID]

        case 'deziiign_book':
            return [
                BOOK_TAG_ID
            ]
        
        case CHILD_BOOK_ID: 
            return [CHILD_BOOK_ID]

        case VIMMELBUH_ID:
            return [VIMMELBUH_ID]

        // case HSEFONTS_TAG:
        //     return [TYPE_TAG_ID]

        case TERBRANDING_TAG: 
            return [TERRITORIAL_BRANDING_ID]

        case POSTER_TAG_ID:
            return [POSTER_TAG_ID]

        case AD_POSTER_TAG:
            return [AD_POSTER_TAG]

        case SOCIAL_POSTER_TAG:
            return [SOCIAL_POSTER_TAG]

        case THEATER_POSTER_TAG:
            return [THEATER_POSTER_TAG]

        case MUSEUM_BRANDING_TAG:
            return [MUSEUM_BRANDING_TAG]

        case MUSEUM_DESIGN_TAG:
            return [MUSEUM_DESIGN_TAG]

        // case HSEPOSTERLAB_TAG:
        //     return [POSTER_TAG_ID]
        
        // case HSESCREENS_TAG:
        //     return [VIDEO_ART_TAG_ID, ANIMATION_TAG_ID]

        // case AILAB_TAG:
        //     return [
        //         AI_TAG_ID
        //     ]
        
        // case ADCODINGHUB_TAG:
        //     return [
        //         CREATIVE_PROGRAMMING_TAG_ID,
        //         DIGITAL_PRODUCT_TAG_ID,
        //         WEB_PUBLISH_TAG_ID
        //     ]
        
        case CALENDAR_DESIGN_ID:
            return [CALENDAR_DESIGN_ID]
        
        case FOOD_PACKAGINGLAB_TAG: 
            return [FOOD_PACKAGINGLAB_TAG_ID]

        case BEVERAGE_PACKAGINGLAB_TAG: 
            return [BEVERAGE_PACKAGINGLAB_TAG_ID]
            
        case BODY_PACKAGINGLAB_TAG: 
            return [BODY_PACKAGINGLAB_TAG_ID]

        case DESIGN_HSEPERM_TAG_ID: 
            return [COMMUNICATION_TAG_ID, BASE_COMMUN_DESIGN_TAG_ID, WEB_PUBLISH_TAG_ID, CREATIVE_PROGRAMMING_TAG_ID, DIGITAL_PRODUCT_TAG_ID ]

        case ANIMATION_FOR_HSEPERM_TAG_ID:
            return [ANIMATION_TAG_ID, ILLUSTRATION_TAG_ID, BASE_COURSE_ANIMATION_TAG_ID]
        
        case GAME_DESIGN_TAG_ID: 
            return [GAME_DESIGN_TAG_ID]
        case BASIC_DESIGN_COURSE_TAG_ID:
            return [BASIC_DESIGN_COURSE_TAG_ID, CREATIVE_BU_TAG_ID]

        case MANAGEMENT_TAG_ID: 
            return [BASIC_DESIGN_COURSE_TAG_ID, CREATIVE_BU_TAG_ID]

        case FANTASY_TAG_ID:
            return [FANTASY_TAG_ID]

        case EVENTS_TAD_ID: 
            return [
                // EVENTS_TAD_ID,
                CONF_TAG_ID,
                FEST_TAG_ID,
                PERFORMANCE_TAG_ID,
                THEATER_AND_PERF_TAG_ID,
                SHADOW_THEATRE_TAG_ID,
                FESTIVAL_TAG_ID,
                SHOW_TAG_ID,
            ]

        case STARTSUP_TAG_ID:
            return [STARTSUP_TAG_ID]

        case ARTIST_TAG_ID: 
            return [/*ART_TAG_ID,*/ BASE_COURSE_MODERN_DESIGN_TAG_ID, VIDEO_ART_TAG_ID, FINE_ART_TAG_ID, DIGITAL_ART_TAG_ID, MODERN_ART_TAG_ID, CINEMA_TAG_ID ]

        case AI_TAG_ID:
            return [AI_TAG_ID]

        case GALLERYS_TAG_ID:
            return [HSE_ART_TAG_ID]

        case RUSSIA_TAG_ID:
            return [RUSSIA_TAG_ID];

        case 'geo_all' :
            return ['geo_all'];
        
        case 'null' :
            return ['null'];

        case EU_TAG_ID:
            return [
                AUSTRIA_TAG_ID,
                GB_TAG_ID,
                GER_TAG_ID,
                IRL_TAG_ID,
                LIHT_TAG_ID,
                LUX_TAG_ID,
                FR_TAG_ID,
                SWISS_TAG_ID,
                ISL_TAG_ID,
                POL_TAG_ID,
                NOWR_TAG_ID,
                FINL_TAG_ID,
                SWE_TAG_ID,
                SPAIN_TAG_ID,
                IT_TAG_ID
            ];
        case FOOD_TAG_ID: 
        return [
            RUS_FOOD_TAG_ID,
            GOR_FOOD_TAG_ID,
            JAP_FOOD_TAG_ID,
            IT_FOOD_TAG_ID,
            FR_FOOD_TAG_ID,
            CHI_FOOD_TAG_ID,
            SPA_FOOD_TAG_ID,
            MEX_FOOD_TAG_ID,
            IND_FOOD_TAG_ID,
            TUR_FOOD_TAG_ID,
            AR_FOOD_TAG_ID,
            TAI_FOOD_TAG_ID,
            KOR_FOOD_TAG_ID,
            AFR_FOOD_TAG_ID,
            RESTAURANT_TAG_ID,
            CAFE_TAG_ID,
            COOKING_ID
        ]

        case 'vs_all':
        case 'visual_research_main': 
            return [
                VISUAL_RES_TAG_ID_BL,
                VISUAL_RESEARCH_TAG_GRADUATION_BLACK,
                // VISUAL_RESEARCH_TAG_GRADUATION_WHITE
            ]

        case CULTURE_TAG_ID: 
            return [
                MUSEUM_NEW_TAG_ID,
                ARCH_TAG_ID,
                MUSEUM_TAG_ID,
                LIBRARY_TAG_ID,
                LIT_TAG_ID,
                MUSIC_TAG_ID,
                THEATRE_TAG_ID,
                EXPOSITION_TAG_ID,
                NATION_CRAFT_TAG_ID
            ]
            
        case CITIES_TAG_ID:
            return [
                CITIES_TAG_ID
            ]

        default:
          return null;
    }
  }import {
    ILLUSTRATION_TAG_ID,
    ANIMATION_TAG_ID,
    BOOK_TAG_ID,
    INFOGRAPHICS_TAG_ID,

    BRAND_TAG_ID,
    FASHION_TAG_ID,
    ART_TAG_ID,
    DESIGN_EDUCATION_TAG_ID,
    INTERIOR_TAG_ID,
    LANDSCAPING_TER_ID,
    PUBLIC_PLACE_ID,
    TERRITORIAL_BRANDING_ID,
    URBAN_ENVIRONMENT_ID,
    DESIGN_TAG_ID,
    JEWELRY_TAG_ID,

    ADVERTISING_TAG_ID,
    ART_DIRECTION_TAG_ID,
    ANIMATION_FOR_HSEPERM_TAG_ID,
    WEB_PUBLISH_TAG_ID,
    BOOK_DESIGN_TAD_ID,
    BASIC_DESIGN_TA_ID,
    COMMUNICATION_TAG_ID,
    CREATIVE_PROGRAMMING_TAG_ID,
    DIGITAL_PRODUCT_TAG_ID,
    INTERACTIVE_DESIGN_TAG_ID,
    MEDIA_DESIGN_TAG_ID,
    MODERN_DESIGN_TAG_ID,
    OBJECT_DESIGN_TAG_ID,
    PACKAGING_TAG_ID,
    TYPE_TAG_ID,
    CANTEMPORARY_ART_TAG_ID,
    PHOTOGRAPHY_ART_TAG_ID,
    VIDEO_ART_ART_TAG_ID,
    FASHION_MANT_TAG_ID,
    TOUR_TAG_ID,

    COLAB_ID,
    FASHION_COLAB_ID,
    BOOK_DESIGN_ID,
    CHILD_BOOK_ID,
    VIMMELBUH_ID,
    CALENDAR_DESIGN_ID,
    CURATOR_ID,
    VIRTUAL_ID,
    PICTURE_BOOK_ID,
    PERFORMANS_ID,
    PUBLIC_ART_ID,
    DESIGN_HISTORY_ID,
    ART_HISTORY_ID,
    COMICS_TAG_ID,
    ILLUSTRATION_IDENTIC_ID,
    VISUAL_RES_TAG_ID_BL,
    BASE_COURSE_ANIMATION_TAG_ID,
    GAME_DESIGN_TAG_ID,
    DESIGN_HSEPERM_TAG_ID,
    BASE_COMMUN_DESIGN_TAG_ID,
    BASIC_DESIGN_COURSE_TAG_ID,
    EVENTS_TAD_ID,
    SPACE_TAG_ID,
    ARTIST_TAG_ID,
    GALLERYS_TAG_ID,
    RUSSIA_TAG_ID,
    EU_TAG_ID,
    STARTSUP_TAG_ID,
    HSE_ART_TAG_ID,
    PLACES_TAG_ID,

    AUSTRIA_TAG_ID,
    GB_TAG_ID,
    GER_TAG_ID,
    IRL_TAG_ID,
    LIHT_TAG_ID,
    LUX_TAG_ID,
    FR_TAG_ID,
    SWISS_TAG_ID,
    ISL_TAG_ID,
    POL_TAG_ID,
    NOWR_TAG_ID,
    FINL_TAG_ID,
    SWE_TAG_ID,
    SPAIN_TAG_ID,
    IT_TAG_ID,
    FOOD_TAG_ID,
    INTERIOR_DESIGN_TAG_ID,
    RUS_FOOD_TAG_ID,
    GOR_FOOD_TAG_ID,
    JAP_FOOD_TAG_ID,
    IT_FOOD_TAG_ID,
    FR_FOOD_TAG_ID,
    CHI_FOOD_TAG_ID,
    SPA_FOOD_TAG_ID,
    MEX_FOOD_TAG_ID,
    IND_FOOD_TAG_ID,
    TUR_FOOD_TAG_ID,
    AR_FOOD_TAG_ID,
    TAI_FOOD_TAG_ID,
    KOR_FOOD_TAG_ID,
    AFR_FOOD_TAG_ID,
    CULTURE_TAG_ID,
    ARCH_TAG_ID,
    LIT_TAG_ID,
    MUSIC_TAG_ID,
    THEATRE_TAG_ID,
    EXPOSITION_TAG_ID,
    NATION_CRAFT_TAG_ID,
    CITIES_TAG_ID,
    CREATIVE_FUTURES_TAG_ID,
    DESIGN_FUTURES_TAG_ID,
    INTER_DESIGN_TAG_ID,
    HISTORY_INVESTIGATE_TAG_ID,

    CONF_TAG_ID,
    FEST_TAG_ID,
    PERFORMANCE_TAG_ID,
    THEATER_AND_PERF_TAG_ID,
    SHADOW_THEATRE_TAG_ID,
    FESTIVAL_TAG_ID,
    SHOW_TAG_ID,
    VISUAL_RESEARCH_TAG_GRADUATION_BLACK,
    VISUAL_RESEARCH_TAG_GRADUATION_WHITE,
    CREATIVE_BU_TAG_ID,
    NATURE_DESIGN_TAG_ID,

    RESEARCH_TAG_ID,
    THEMES_TAG_ID,
    ALL_RESEARCH_TAG_ID,

    SOUND_TAG_ID,
    SOUND_ART_TAG_ID,
    RESTAURANT_TAG_ID,
    CAFE_TAG_ID,
    PEOPLE_TAG_ID,
    FINANCE_TAG_ID,
    NATURE_TAG_ID,
    ECOLOGY_TAG_ID,
    FLORA_AND_FAUNA_TAG_ID,
    SPORT_TAG_ID,
    CREATIVE_COOK_TAG_ID,
    HOLIDAYS_TAG_ID,
    VIDEO_ART_TAG_ID,
    MODERN_ART_TAG_ID,
    HSELAB_DESIGN_TAG_ID,
    EVENTS_DESIGN_TAG_ID,
    MANAGEMENT_TAG_ID,
    BASE_DESIGN_COURSE,
    COOKING_ID,
    GAME_FUTURES_TAG_ID,
    MUSEUM_TAG_ID,
    MUSEUM_NEW_TAG_ID,
    LIBRARY_TAG_ID,
    TRANSPORT_TAG_ID,
    INDUSTRY_TAG_ID,
    BRANDS_TAG_ID,

    D_PERSON_TAG_ID,
    D_MODEL_TAG_ID,
    VIDEO_GAME_TAG_ID,
    GAME_GRAPHIC_TAG_ID,
    ANIMATIC_TAG_ID,
    FANTASY_TAG_ID,
    ILLUSTRATED_BOOK_TAG_ID,
    FOOD_PACKAGINGLAB_TAG,
    FOOD_PACKAGINGLAB_TAG_ID,
    BEVERAGE_PACKAGINGLAB_TAG,
    BEVERAGE_PACKAGINGLAB_TAG_ID,
    BODY_PACKAGINGLAB_TAG,
    BODY_PACKAGINGLAB_TAG_ID,
    ADCODINGHUB_TAG,
    AILAB_TAG,
    AI_TAG_ID,
    HSEFONTS_TAG,
    PRINTING_HOUSE_TAG,
    HSEMULTIMEDIA_TAG,
    TERBRANDING_TAG,
    HSEPOSTERLAB_TAG,
    POSTER_TAG_ID,
    HSESCREENS_TAG,
    HSECOLLECTION_PORCELAIN_TAG_ID,
    HSECOLLECTION_TEXTILE_TAG_ID,
    HSECOLLECTION_SILCSCREEN_TAG_ID,
    HSECOLLECTION_CALENDARS_TAG_ID,
    HSECOLLECTION_PORCELAIN_TAG,
    HSECOLLECTION_TEXTILE_TAG,
    HSECOLLECTION_SILCSCREEN_TAG,
    HSECOLLECTION_CALENDARS_TAG,
    HSEPHOTOLAB_TAG,
    EDUDESIGN_TAG,
    EDU_BRANDING_TAG_ID,
    CAMPUS_TAG_ID,
    PRODUCTION_TAG,

    ARRANGEMENT_TAG_ID,
    VOCAL_MUSIC_TAG_ID,
    CLASSIC_MUSIC_TAG_ID,
    MIX_TAG_ID,
    MUSICAL_COMPOSITION_TAG_ID,
    MUSICAL_ALBUM_TAG_ID,
    POP_MUSIC_TAG_ID,
    ROCK_MUSIC_TAG_ID,
    MIXING_AND_MASTERING_TAG_ID,
    DANCING_MUSIC_TAG_ID,
    INSTR_MUSIC_TAG_ID,

    SOUND_PRODUCTION_TAG_ID,
    MUSICAL_PROJECT_TAG_ID,
    STUDIO_RECORDING_TAG_ID,
    ORCHESTRA_TAG_ID,
    PRESS_PACK_TAG_ID,
    SOUND_SINTHESIS_TAG_ID,
    AUDIOMEDIA_TAG_ID,
    SOUND_DESIGN_TAG,

    SOUND_IDENTITY_TAG_ID,
    AUDIO_BRANDING_TAG_ID,
    SOUND_LIBRARY_TAG_ID,
    ANIMATION_MUSIC_TAG_ID,
    FILMS_MUSIC_TAG_ID,
    CATWALK_MUSIC_TAG_ID,
    ADVERTISING_MUSIC_TAG_ID,
    THEATRE_MUSIC_TAG_ID,
    PATCH_TAG_ID,
    SOUND_TRACK_TAG_ID,
    BACKGROUND_MUSIC_TAG_ID,
    FUNCTIONAL_MUSIC_TAG_ID,
    SOUND_DESIGN_TAG_ID,
    SOUND_ART_TAG,

    SOUND_INSTALLATION_TAG_ID,
    SOUND_SCULPTURE_TAG_ID,
    MULTI_INSTALLATION_TAG_ID,
    MULTIMEDIA_PERFORMANCE_TAG_ID,
    FIELD_RECORDS_TAG_ID,
    EXP_MUSIC_TAG_ID,
    ELECTROACOUSTIC_MUSIC_TAG_ID,

    SOUNDART_TAG_ID,
    NOISE_MUSIC_TAG_ID,
    MUSIC_PRACTICE_TAG_ID,
    SOUNDSCAPE_TAG_ID,
    SONIFICATION_TAG_ID,
    ALHORITMIC_MUSIC_TAG_ID,
    SOUND_POETRY_TAG_ID,
    MUSIC_CONCRETE_TAG_ID,
    STUDIES_TAG,

    SOUND_STUDIES_TAG_ID,
    MUSICAL_CRITICISM,
    SOUND_PHILOSOPHY,
    SOUND_ECOLOGY_TAG_ID,
    SOUNDLAB_TAG,

    MUSICAL_LABEL_TAG_ID,
    SOUNDLAB_TAG_ID,
    AD_POSTER_TAG, SOCIAL_POSTER_TAG, THEATER_POSTER_TAG, MUSEUM_BRANDING_TAG, MUSEUM_DESIGN_TAG,
    EXPLAINERS_TAG_ID,
    TVDESIGN_TAG_ID,
    MUSIC_CLIPS_TAG_ID,
    DDD_POST_PROD_TAG_ID,
    SOUND_ALL_TAG,
    DIGITAL_ART_NEW_TAG_ID, 
    FINE_ART_TAG_ID,
    EDUCATION_COURSE,
    BASE_COURSE_MODERN_DESIGN_TAG_ID,
    DIGITAL_ART_TAG_ID,
    CINEMA_TAG_ID,
    EVENT_MANAGER_TAG_ID,
    MEDIA_STARTUP_TAG_ID,
    PRODUCER_TAG_ID,
    PRINT_PRODUCT_TAG_ID,
    MANU_DESIGN_TAG_ID,
    HSEILLUSTRATION_TAG_ID,
    CONCEPT_ART_TAG_ID,
    CGI_TAG_ID,
    VIDEO_TAG_ID,
    BOARD_GAME_ID


} from '../../../constants/misc';
import { ContextCodes } from './tabs';

export const getContextTagsFilterParam = (id: string, context?: string): string[] | null => {
    if (context === ContextCodes.deziiignMain) {
        switch (id) {
            case DESIGN_TAG_ID:
                return [
                    ART_DIRECTION_TAG_ID, 
                    PACKAGING_TAG_ID, 
                    INFOGRAPHICS_TAG_ID, 
                    INTERACTIVE_DESIGN_TAG_ID, 
                    PRINT_PRODUCT_TAG_ID, 
                    MEDIA_DESIGN_TAG_ID, 
                    POSTER_TAG_ID, 
                    ADVERTISING_TAG_ID, 
                    TYPE_TAG_ID, 
                    DIGITAL_PRODUCT_TAG_ID, 
                    CREATIVE_PROGRAMMING_TAG_ID, 
                    WEB_PUBLISH_TAG_ID, 
                    MEDIA_DESIGN_TAG_ID, 
                    // AI_TAG_ID, 
                    BOOK_TAG_ID
                ]
            case 'product':
                return [
                    OBJECT_DESIGN_TAG_ID, 
                    MANU_DESIGN_TAG_ID, 
                    JEWELRY_TAG_ID
                ]
            case 'environment':
                return [
                    INTER_DESIGN_TAG_ID,
                    NATURE_DESIGN_TAG_ID
                ]
            case ILLUSTRATION_TAG_ID:
                return [
                    HSEILLUSTRATION_TAG_ID,
                    COMICS_TAG_ID,
                    CHILD_BOOK_ID,
                    BOARD_GAME_ID 
                ]
        }
    }
    switch (id) {
        case EDUCATION_COURSE:
            return [EDUCATION_COURSE]
        case EXPLAINERS_TAG_ID:
            return [EXPLAINERS_TAG_ID]
        case TVDESIGN_TAG_ID:
            return [TVDESIGN_TAG_ID]
        case MUSIC_CLIPS_TAG_ID:
            return [MUSIC_CLIPS_TAG_ID]
        case DDD_POST_PROD_TAG_ID:
            return [DDD_POST_PROD_TAG_ID]
        case SOUNDLAB_TAG:
            return [
                MUSICAL_LABEL_TAG_ID,
                SOUNDLAB_TAG_ID,
            ]
        case SOUND_ALL_TAG:
            return [
                SOUND_TAG_ID
            ]
        case STUDIES_TAG:
            return [
                SOUND_STUDIES_TAG_ID,
                // MUSICAL_CRITICISM,
                // SOUND_PHILOSOPHY,
                // SOUND_ECOLOGY_TAG_ID,
            ]
        case SOUND_ART_TAG:
            return [
                // SOUND_INSTALLATION_TAG_ID,
                // SOUND_SCULPTURE_TAG_ID,
                // MULTI_INSTALLATION_TAG_ID,
                // MULTIMEDIA_PERFORMANCE_TAG_ID,
                // FIELD_RECORDS_TAG_ID,
                // EXP_MUSIC_TAG_ID,
                // ELECTROACOUSTIC_MUSIC_TAG_ID,

                SOUNDART_TAG_ID,
                // NOISE_MUSIC_TAG_ID,
                // MUSIC_PRACTICE_TAG_ID,
                // SOUNDSCAPE_TAG_ID,
                // SONIFICATION_TAG_ID,
                // ALHORITMIC_MUSIC_TAG_ID,
                // SOUND_POETRY_TAG_ID,
                // MUSIC_CONCRETE_TAG_ID,
            ]
        case SOUND_DESIGN_TAG: 
            return [
                // SOUND_IDENTITY_TAG_ID,
                // AUDIO_BRANDING_TAG_ID,
                // SOUND_LIBRARY_TAG_ID,
                // ANIMATION_MUSIC_TAG_ID,
                // FILMS_MUSIC_TAG_ID,
                // CATWALK_MUSIC_TAG_ID,
                // ADVERTISING_MUSIC_TAG_ID,
                // THEATRE_MUSIC_TAG_ID,
                // PATCH_TAG_ID,
                // SOUND_TRACK_TAG_ID,
                // BACKGROUND_MUSIC_TAG_ID,
                // FUNCTIONAL_MUSIC_TAG_ID,
                SOUND_DESIGN_TAG_ID,
            ]
        case PRODUCTION_TAG:
            return [
                // ARRANGEMENT_TAG_ID,
                // VOCAL_MUSIC_TAG_ID,
                // CLASSIC_MUSIC_TAG_ID,
                // MIX_TAG_ID,
                // MUSICAL_COMPOSITION_TAG_ID,
                // MUSICAL_ALBUM_TAG_ID,
                // POP_MUSIC_TAG_ID,
                // ROCK_MUSIC_TAG_ID,
                // MIXING_AND_MASTERING_TAG_ID,
                // DANCING_MUSIC_TAG_ID,
                // INSTR_MUSIC_TAG_ID,

                SOUND_PRODUCTION_TAG_ID,
                // MUSICAL_PROJECT_TAG_ID,
                // STUDIO_RECORDING_TAG_ID,
                // ORCHESTRA_TAG_ID,
                // PRESS_PACK_TAG_ID,
                // SOUND_SINTHESIS_TAG_ID,
                // AUDIOMEDIA_TAG_ID,
            ]
        case EDUDESIGN_TAG:
            return [EDU_BRANDING_TAG_ID, DESIGN_EDUCATION_TAG_ID, CAMPUS_TAG_ID]
        case HSECOLLECTION_PORCELAIN_TAG:
            return  [
                HSECOLLECTION_PORCELAIN_TAG_ID
            ]
        case HSECOLLECTION_TEXTILE_TAG:
            return [HSECOLLECTION_TEXTILE_TAG_ID]
        case HSECOLLECTION_SILCSCREEN_TAG:
            return [
                HSECOLLECTION_SILCSCREEN_TAG_ID
            ]
        case HSECOLLECTION_CALENDARS_TAG:
            return [HSECOLLECTION_CALENDARS_TAG_ID]

        case D_PERSON_TAG_ID:
            return [D_PERSON_TAG_ID, D_MODEL_TAG_ID]
        case VIDEO_GAME_TAG_ID:
            return [VIDEO_GAME_TAG_ID, GAME_GRAPHIC_TAG_ID]
        case ANIMATIC_TAG_ID:
            return [ANIMATIC_TAG_ID]
        case TOUR_TAG_ID: 
            return [TOUR_TAG_ID]
        case PEOPLE_TAG_ID:
            return [PEOPLE_TAG_ID, ARTIST_TAG_ID]
        case FINANCE_TAG_ID:
            return [ TRANSPORT_TAG_ID, /*INDUSTRY_TAG_ID, */BRANDS_TAG_ID, TRANSPORT_TAG_ID]
        case NATURE_TAG_ID: 
            return [NATURE_TAG_ID, ECOLOGY_TAG_ID, FLORA_AND_FAUNA_TAG_ID]
        case SPORT_TAG_ID:
            return [SPORT_TAG_ID]
        case CREATIVE_COOK_TAG_ID:
            return [
                FOOD_TAG_ID,
                RUS_FOOD_TAG_ID,
                GOR_FOOD_TAG_ID,
                JAP_FOOD_TAG_ID,
                IT_FOOD_TAG_ID,
                FR_FOOD_TAG_ID,
                CHI_FOOD_TAG_ID,
                SPA_FOOD_TAG_ID,
                MEX_FOOD_TAG_ID,
                IND_FOOD_TAG_ID,
                TUR_FOOD_TAG_ID,
                AR_FOOD_TAG_ID,
                TAI_FOOD_TAG_ID,
                KOR_FOOD_TAG_ID,
                AFR_FOOD_TAG_ID,
            ]
        case HOLIDAYS_TAG_ID:
            return [
                HOLIDAYS_TAG_ID,
                 EVENTS_TAD_ID,

                 CONF_TAG_ID,
                 FEST_TAG_ID,
                 PERFORMANCE_TAG_ID,
                 THEATER_AND_PERF_TAG_ID,
                 SHADOW_THEATRE_TAG_ID,
                 FESTIVAL_TAG_ID,
                 SHOW_TAG_ID,
                ]
        case SOUND_ART_TAG_ID:
            return [SOUND_ART_TAG_ID]
        case THEMES_TAG_ID:
            return [DESIGN_TAG_ID]
        case RESEARCH_TAG_ID:
            return [RESEARCH_TAG_ID]
        case HISTORY_INVESTIGATE_TAG_ID:
            return [HISTORY_INVESTIGATE_TAG_ID]
        case ALL_RESEARCH_TAG_ID: 
            return null
      case ILLUSTRATION_TAG_ID:
        return [
            HSEILLUSTRATION_TAG_ID,
            COMICS_TAG_ID,
            CONCEPT_ART_TAG_ID
        ]
  
      case ANIMATION_TAG_ID:
        return [ANIMATION_TAG_ID]
  
      case BOOK_TAG_ID:
          if (context === 'ageytomesh') {
              return []
          }
        return [BOOK_TAG_ID, COMICS_TAG_ID]

        case COMICS_TAG_ID:
            return [COMICS_TAG_ID]

        case ILLUSTRATED_BOOK_TAG_ID:
            return [ILLUSTRATED_BOOK_TAG_ID, VIMMELBUH_ID, PICTURE_BOOK_ID, CHILD_BOOK_ID]
  
        case INFOGRAPHICS_TAG_ID:
        return [INFOGRAPHICS_TAG_ID]

        case DESIGN_FUTURES_TAG_ID:
            return [        
                JEWELRY_TAG_ID,
                OBJECT_DESIGN_TAG_ID,
                COMMUNICATION_TAG_ID,
                NATURE_DESIGN_TAG_ID,
                INTER_DESIGN_TAG_ID
            ]

        case DESIGN_TAG_ID: 
        return [
            // ADVERTISING_TAG_ID,
            // ART_DIRECTION_TAG_ID, 
            // WEB_PUBLISH_TAG_ID, 
            // BOOK_DESIGN_TAD_ID, 
            // // BASIC_DESIGN_TA_ID, 
            // COMMUNICATION_TAG_ID,
            // CREATIVE_PROGRAMMING_TAG_ID,
            // DIGITAL_PRODUCT_TAG_ID,
            // INTERACTIVE_DESIGN_TAG_ID,
            // MEDIA_DESIGN_TAG_ID,
            // // MODERN_DESIGN_TAG_ID,
            // OBJECT_DESIGN_TAG_ID,
            // PACKAGING_TAG_ID,
            // TYPE_TAG_ID

            THEATER_AND_PERF_TAG_ID,
            EVENT_MANAGER_TAG_ID,
            CREATIVE_BU_TAG_ID,
            MEDIA_STARTUP_TAG_ID,
            PRODUCER_TAG_ID,
            ART_DIRECTION_TAG_ID,
            BASIC_DESIGN_COURSE_TAG_ID,
            WEB_PUBLISH_TAG_ID,
            BOOK_TAG_ID,
            PACKAGING_TAG_ID,
            INFOGRAPHICS_TAG_ID,
            AI_TAG_ID,

            DDD_POST_PROD_TAG_ID,
            CGI_TAG_ID,
            ANIMATION_TAG_ID,
            VIDEO_TAG_ID,
            VIDEO_ART_TAG_ID,
            CINEMA_TAG_ID,
            PRODUCER_TAG_ID,
            CREATIVE_PROGRAMMING_TAG_ID,
            INTERACTIVE_DESIGN_TAG_ID,
            PRINT_PRODUCT_TAG_ID,
            POSTER_TAG_ID,
            ADVERTISING_TAG_ID,
            DIGITAL_PRODUCT_TAG_ID,
            TYPE_TAG_ID,
            MEDIA_DESIGN_TAG_ID,
            OBJECT_DESIGN_TAG_ID,
            MANU_DESIGN_TAG_ID,
            JEWELRY_TAG_ID,
            HSEILLUSTRATION_TAG_ID,
            COMICS_TAG_ID,
            CONCEPT_ART_TAG_ID,
            // SOUND_TAG_ID


        ]

        case INTERIOR_TAG_ID:
            return [
                INTERIOR_TAG_ID, 
                PUBLIC_PLACE_ID,
                NATURE_DESIGN_TAG_ID,
                INTERIOR_DESIGN_TAG_ID
            ]

        case DESIGN_EDUCATION_TAG_ID: 
            return [DESIGN_EDUCATION_TAG_ID]

        case HSELAB_DESIGN_TAG_ID:
            return [
                ART_DIRECTION_TAG_ID, 
                BOOK_DESIGN_TAD_ID, 
                COMMUNICATION_TAG_ID,
                OBJECT_DESIGN_TAG_ID,
                EVENTS_DESIGN_TAG_ID
            ]

        case TERRITORIAL_BRANDING_ID:
            return [
                LANDSCAPING_TER_ID, 
                URBAN_ENVIRONMENT_ID, 
                TERRITORIAL_BRANDING_ID,
                NATION_CRAFT_TAG_ID,
                CITIES_TAG_ID,
                PLACES_TAG_ID
            ]

        case ART_TAG_ID:
            return [
                CANTEMPORARY_ART_TAG_ID,
                PHOTOGRAPHY_ART_TAG_ID,
                VIDEO_ART_ART_TAG_ID
            ]
        case FASHION_MANT_TAG_ID: 
            return [FASHION_TAG_ID]
        
        case GAME_FUTURES_TAG_ID: 
            return [GAME_DESIGN_TAG_ID]

        case FASHION_TAG_ID:
            return [
                FASHION_TAG_ID,
                PHOTOGRAPHY_ART_TAG_ID
            ]
        case 'environment': 
        return [
            INTER_DESIGN_TAG_ID,
            NATURE_DESIGN_TAG_ID
        ]

        case COLAB_ID: 
            return [COLAB_ID]

        case FASHION_COLAB_ID:
            return [FASHION_COLAB_ID]
        
        case CURATOR_ID :
            return [CURATOR_ID];
            
        case PICTURE_BOOK_ID:
            return [PICTURE_BOOK_ID]
        
        case PERFORMANS_ID:
            return [PERFORMANS_ID]
        
        case PUBLIC_ART_ID:
            return [PUBLIC_ART_ID]

        case DESIGN_HISTORY_ID:
            return [DESIGN_HISTORY_ID]
            // return [DESIGN_HISTORY_ID, VISUAL_RES_TAG_ID_BL, VISUAL_RES_TAG_ID_WHT]
        
        case ART_HISTORY_ID:
            return [ART_HISTORY_ID]
            // return [ART_HISTORY_ID, VISUAL_RES_TAG_ID_BL, VISUAL_RES_TAG_ID_WHT]

        case BOOK_DESIGN_ID: 
            return [BOOK_DESIGN_ID]

        case 'deziiign_book':
            return [
                BOOK_TAG_ID
            ]
        
        case CHILD_BOOK_ID: 
            return [CHILD_BOOK_ID]

        case VIMMELBUH_ID:
            return [VIMMELBUH_ID]

        // case HSEFONTS_TAG:
        //     return [TYPE_TAG_ID]

        case TERBRANDING_TAG: 
            return [TERRITORIAL_BRANDING_ID]

        case POSTER_TAG_ID:
            return [POSTER_TAG_ID]

        case AD_POSTER_TAG:
            return [AD_POSTER_TAG]

        case SOCIAL_POSTER_TAG:
            return [SOCIAL_POSTER_TAG]

        case THEATER_POSTER_TAG:
            return [THEATER_POSTER_TAG]

        case MUSEUM_BRANDING_TAG:
            return [MUSEUM_BRANDING_TAG]

        case MUSEUM_DESIGN_TAG:
            return [MUSEUM_DESIGN_TAG]

        // case HSEPOSTERLAB_TAG:
        //     return [POSTER_TAG_ID]
        
        // case HSESCREENS_TAG:
        //     return [VIDEO_ART_TAG_ID, ANIMATION_TAG_ID]

        // case AILAB_TAG:
        //     return [
        //         AI_TAG_ID
        //     ]
        
        // case ADCODINGHUB_TAG:
        //     return [
        //         CREATIVE_PROGRAMMING_TAG_ID,
        //         DIGITAL_PRODUCT_TAG_ID,
        //         WEB_PUBLISH_TAG_ID
        //     ]
        
        case CALENDAR_DESIGN_ID:
            return [CALENDAR_DESIGN_ID]
        
        case FOOD_PACKAGINGLAB_TAG: 
            return [FOOD_PACKAGINGLAB_TAG_ID]

        case BEVERAGE_PACKAGINGLAB_TAG: 
            return [BEVERAGE_PACKAGINGLAB_TAG_ID]
            
        case BODY_PACKAGINGLAB_TAG: 
            return [BODY_PACKAGINGLAB_TAG_ID]

        case DESIGN_HSEPERM_TAG_ID: 
            return [COMMUNICATION_TAG_ID, BASE_COMMUN_DESIGN_TAG_ID, WEB_PUBLISH_TAG_ID, CREATIVE_PROGRAMMING_TAG_ID, DIGITAL_PRODUCT_TAG_ID ]

        case ANIMATION_FOR_HSEPERM_TAG_ID:
            return [ANIMATION_TAG_ID, ILLUSTRATION_TAG_ID, BASE_COURSE_ANIMATION_TAG_ID]
        
        case GAME_DESIGN_TAG_ID: 
            return [GAME_DESIGN_TAG_ID]
        case BASIC_DESIGN_COURSE_TAG_ID:
            return [BASIC_DESIGN_COURSE_TAG_ID, CREATIVE_BU_TAG_ID]

        case MANAGEMENT_TAG_ID: 
            return [BASIC_DESIGN_COURSE_TAG_ID, CREATIVE_BU_TAG_ID]

        case FANTASY_TAG_ID:
            return [FANTASY_TAG_ID]

        case EVENTS_TAD_ID: 
            return [
                // EVENTS_TAD_ID,
                CONF_TAG_ID,
                FEST_TAG_ID,
                PERFORMANCE_TAG_ID,
                THEATER_AND_PERF_TAG_ID,
                SHADOW_THEATRE_TAG_ID,
                FESTIVAL_TAG_ID,
                SHOW_TAG_ID,
            ]

        case STARTSUP_TAG_ID:
            return [STARTSUP_TAG_ID]

        case ARTIST_TAG_ID: 
            return [/*ART_TAG_ID,*/ BASE_COURSE_MODERN_DESIGN_TAG_ID, VIDEO_ART_TAG_ID, FINE_ART_TAG_ID, DIGITAL_ART_TAG_ID, MODERN_ART_TAG_ID, CINEMA_TAG_ID ]

        case AI_TAG_ID:
            return [AI_TAG_ID]

        case GALLERYS_TAG_ID:
            return [HSE_ART_TAG_ID]

        case RUSSIA_TAG_ID:
            return [RUSSIA_TAG_ID];

        case 'geo_all' :
            return ['geo_all'];
        
        case 'null' :
            return ['null'];

        case EU_TAG_ID:
            return [
                AUSTRIA_TAG_ID,
                GB_TAG_ID,
                GER_TAG_ID,
                IRL_TAG_ID,
                LIHT_TAG_ID,
                LUX_TAG_ID,
                FR_TAG_ID,
                SWISS_TAG_ID,
                ISL_TAG_ID,
                POL_TAG_ID,
                NOWR_TAG_ID,
                FINL_TAG_ID,
                SWE_TAG_ID,
                SPAIN_TAG_ID,
                IT_TAG_ID
            ];
        case FOOD_TAG_ID: 
        return [
            RUS_FOOD_TAG_ID,
            GOR_FOOD_TAG_ID,
            JAP_FOOD_TAG_ID,
            IT_FOOD_TAG_ID,
            FR_FOOD_TAG_ID,
            CHI_FOOD_TAG_ID,
            SPA_FOOD_TAG_ID,
            MEX_FOOD_TAG_ID,
            IND_FOOD_TAG_ID,
            TUR_FOOD_TAG_ID,
            AR_FOOD_TAG_ID,
            TAI_FOOD_TAG_ID,
            KOR_FOOD_TAG_ID,
            AFR_FOOD_TAG_ID,
            RESTAURANT_TAG_ID,
            CAFE_TAG_ID,
            COOKING_ID
        ]

        case 'vs_all':
        case 'visual_research_main': 
            return [
                VISUAL_RES_TAG_ID_BL,
                VISUAL_RESEARCH_TAG_GRADUATION_BLACK,
                // VISUAL_RESEARCH_TAG_GRADUATION_WHITE
            ]

        case CULTURE_TAG_ID: 
            return [
                MUSEUM_NEW_TAG_ID,
                ARCH_TAG_ID,
                MUSEUM_TAG_ID,
                LIBRARY_TAG_ID,
                LIT_TAG_ID,
                MUSIC_TAG_ID,
                THEATRE_TAG_ID,
                EXPOSITION_TAG_ID,
                NATION_CRAFT_TAG_ID
            ]
            
        case CITIES_TAG_ID:
            return [
                CITIES_TAG_ID
            ]

        default:
          return null;
    }
  }